module.exports = __webpack_public_path__ + "static/media/introduction.78647e11.png";